import { client } from '../graphql.service';

const GET_CUSTOM_BRANDING_BY_SLUG = `
  query getCustomBrandingBySlug($input: BrandingSlugInput!) {
    Tenant {
      customBrandingBySlug(input: $input) {
        tenantId
        tenantName
        faviconUrl
        faviconFileUuid
        logoUrl
        logoFileUuid
        primaryColor
      }
    }
  }
`;

export type CustomBrandingBySlugResult = {
  tenantId?: string | null;
  tenantName?: string | null;
  faviconUrl?: string | null;
  faviconFileUuid?: string | null;
  logoUrl?: string | null;
  logoFileUuid?: string | null;
  primaryColor?: string | null;
};

type Response = {
  Tenant?: {
    customBrandingBySlug?: CustomBrandingBySlugResult | null;
  } | null;
};

/**
 * Fetches custom branding by room slug via GraphQL. Does not use RTK Query,
 * so it can be used above the Redux provider (e.g. clinic sign-in page).
 */
export async function fetchCustomBrandingBySlug(
  slug: string,
): Promise<CustomBrandingBySlugResult | null> {
  const data = await client.request<Response>(GET_CUSTOM_BRANDING_BY_SLUG, {
    input: { slug },
  });
  return data?.Tenant?.customBrandingBySlug ?? null;
}
